import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
import "./router/permission"
import './plugins/element.js';
import "./style/tailwindcss.css"
import './style/index.less';
import DZModelSystemConfig from './model/DZModelSystemConfig';
import './style/iconfont/iconfont.css'
import '@/style/iconfont/iconfont'
import JsonExcel from 'vue-json-excel'
import ImgUtil from "@/utils/ImgUtil";

Vue.prototype.$nyImg = new ImgUtil();
Vue.prototype.$nyPrint = new printUtil();

Vue.component('downloadExcel', JsonExcel)

// 动态修改浏览器标题
document.title = process.env.VUE_APP_ProjectName;

// 扩展
import '@/extension/nyString.extensions'
import printUtil from "@/utils/print";

// 公共Model
Vue.prototype.$dzSystem = new DZModelSystemConfig();
Vue.config.productionTip = false;

Vue.prototype.$has = (value)=>{
  let flag = false
  if(store.state.user.auth){
    if (store.state.user.auth.indexOf(value) > -1) {
      flag = true
    }
  }
  return flag
}

Vue.directive('has',{
  inserted:(el, binding)=>{
    const {value} = binding
    if(value){
      if(!Vue.prototype.$has(value)){
        el.parentNode.removeChild(el)
      }
    }else {
      throw new Error(`need roles like v-has="['update']"`)
    }
  }
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
